"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendReconciliationEvent = void 0;
var _1 = require(".");
var sendReconciliationEvent = function (eventDetails) {
    (0, _1.sendEvent)(null, null, null, "ad_eligibility_decision_v0", eventDetails);
};
exports.sendReconciliationEvent = sendReconciliationEvent;
